jQuery(window).on("load", function(){
  // Select the first variant by default
  enableAddToCart();
});
jQuery(document).ready(function(){
  // Select the first variant by default
  initSubscription();

  // Handle desktop search input field click (opens search) - only for desktop
  jQuery(document).on("click", ".search-container-desktop .search__input", function(e){
    e.stopPropagation(); // Prevent event bubbling
    var $desktopSearch = jQuery("#header--search__container-desktop");
    // Make sure mobile search is closed
    jQuery("#header--search__container-mobile").removeClass("active_search");
    if (!$desktopSearch.hasClass("active_search")) {
      $desktopSearch.addClass("active_search");
      jQuery("body").addClass("search-active");
    }
  });

  // Handle mobile search (click on mobile search icon) - only for mobile
  jQuery(document).on("click", ".header-icons-block__search", function(e){
    e.stopPropagation(); // Prevent event bubbling
    var $mobileSearch = jQuery("#header--search__container-mobile");
    // Make sure desktop search is closed
    jQuery("#header--search__container-desktop").removeClass("active_search");
    $mobileSearch.toggleClass("active_search"); 
    if ($mobileSearch.hasClass("active_search")) {
      jQuery("body").addClass("search-active");
    } else {
      jQuery("body").removeClass("search-active");
    }
  });

  // Handle mobile search input field click (opens search if not already open) - only for mobile
  jQuery(document).on("click", ".search-container-mobile .search__input", function(e){
    e.stopPropagation(); // Prevent event bubbling
    var $mobileSearch = jQuery("#header--search__container-mobile");
    // Make sure desktop search is closed
    jQuery("#header--search__container-desktop").removeClass("active_search");
    if (!$mobileSearch.hasClass("active_search")) {
      $mobileSearch.addClass("active_search");
      jQuery("body").addClass("search-active");
    }
  });

  // Handle close button (X) click for both desktop and mobile
  jQuery(document).on("click", ".search-container-desktop .custom_search__input_field__input, .search-container-mobile .custom_search__input_field__input", function(e){
    e.stopPropagation(); // Prevent triggering input field click
    var $searchContainer = jQuery(this).closest('.search-container-desktop, .search-container-mobile');
    var searchId = $searchContainer.attr('id');
    
    if (searchId === 'header--search__container-desktop') {
      var $desktopSearch = jQuery("#header--search__container-desktop");
      $desktopSearch.removeClass("active_search");
      jQuery("body").removeClass("search-active");
    } else if (searchId === 'header--search__container-mobile') {
      var $mobileSearch = jQuery("#header--search__container-mobile");
      $mobileSearch.removeClass("active_search");
      jQuery("body").removeClass("search-active");
    }
  });
  
  jQuery(document).on("click", ".bottom-bar .bottom-bar-flex a.flex-item:nth-child(2)", function(e){
    e.preventDefault();
    jQuery("#Details-menu-drawer-container summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset").click();
  });

  // Handle scroll to close search when scrolling back to top (for homepage transparency) - DESKTOP ONLY
  let scrollTicking = false;
  jQuery(window).on('scroll', function() {
    if (!scrollTicking) {
      window.requestAnimationFrame(function() {
        const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        const body = document.body;
        const windowWidth = window.innerWidth;
        
        // Only on homepage AND desktop (width > 1023px): when scrolled back to top, close search
        // Mobile behavior: search stays open even when scrolling (no auto-close)
        if (body.classList.contains('is-homepage') && windowWidth > 1023 && scrollY <= 0) {
          const isSearchActive = body.classList.contains('search-active');
          
          if (isSearchActive) {
            // Close desktop search only (mobile search remains open when user scrolls)
            jQuery("#header--search__container-desktop").removeClass("active_search");
            jQuery("body").removeClass("search-active");
          }
        }
        
        scrollTicking = false;
      });
      
      scrollTicking = true;
    }
  });

});

function enableAddToCart(){
  // Support for new layout
  const newLayoutSubscribe = document.querySelector('.choosesubscriptionproducts-new .subscribe-card');
  if (newLayoutSubscribe) {
    setTimeout(function(){
      if (newLayoutSubscribe) {
        newLayoutSubscribe.click();
      }
    }, 1000);
  } else {
    // Fallback to old layout
    let monthlySubscriptionInput = document.querySelector('.add-cart-wrapper .current_product_subscription:not(.no-subscription) input');
    if (!monthlySubscriptionInput) {
      monthlySubscriptionInput = document.querySelector('.current_product_subscription:not(.no-subscription) input');
    }
    if (monthlySubscriptionInput) {
      setTimeout(function(){
        monthlySubscriptionInput.click();
      }, 1000);
    }
  }
  
  setTimeout(function () {
    jQuery(".product-form__submit, .buy-now").each(function () {
      var $btn = jQuery(this);
      var label = $btn.find("span").first().text().trim().toLowerCase();

      // Skip if button label says "sold out"
      if (label === "sold out") {
        return; // keep it disabled
      }

      // Otherwise, enable the button
      $btn.removeAttr("disabled").addClass("active");
    });
  }, 500);
}

function initSubscription(){
  // Support for new layout - handled by inline script in the Liquid file
  const newLayout = document.querySelector('.choosesubscriptionproducts-new');
  if (newLayout) {
    // New layout handles its own initialization
    return;
  }
  
  // Fallback to old layout
  jQuery(".single_product:first-child input").click();

  jQuery(document).on("click", ".single_product", function() {
      jQuery(".thumbnail-list, .product__media-list").find("li:first-child").css({ "opacity": 0 });

      jQuery(this).closest(".product__info-container").find('input[name="selling_plan"]').val( jQuery(this).find(".selling_plan_vavaverve").attr("data-selling-plan-id") );
      jQuery(this).closest(".product__info-container").find('input[name="id"]').val( jQuery(this).find(".selling_plan_vavaverve").attr("data-variant-id") );
      jQuery(this).closest(".product__info-container").find('input[name="product-id"]').val( jQuery(this).find(".selling_plan_vavaverve").attr("data-product-id") );
      jQuery(this).closest(".product__info-container").find('input[name="addons_ids"]').val( jQuery(this).find(".selling_plan_vavaverve").attr("data-product-addons") );

      // get the product image on which subscription plan we've clicked
      var product_image = jQuery(this).attr("product-image");
      // update the very first thumbnail and gallery src
      jQuery(".thumbnail-list, .product__media-list").each(function(){
          jQuery(this).find("li:first-child img").attr("src", product_image).attr("srcset", product_image);
          jQuery(".product-media-modal__content").find("img:first-child").attr("src", product_image).attr("srcset", product_image);
          setTimeout(function(){
            jQuery(".thumbnail-list, .product__media-list").find("li:first-child").css({ "opacity": 1 });
          }, 300);
      });
    
      // Click Event to active the block
      jQuery(".single_product").removeClass("rc_block_active");
      var thisItem = jQuery(this);
      setTimeout(function(){
          if ( thisItem.find("input").is(":checked") == true ) {
          thisItem.addClass("rc_block_active");
      } else {
          thisItem.removeClass("rc_block_active");
      }
      }, 100)
  });
}

// document.addEventListener("DOMContentLoaded", function () {
//   // Use a more specific selector to target the Monthly Subscription input
//   enableAddToCart()
// });
